"use strict";

exports.__esModule = true;
exports["default"] = RingAlt;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function RingAlt(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: "uil-ring-alt",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    className: "bk",
    d: "M0 0h100v100H0z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 50,
    cy: 50,
    fill: "none",
    r: 40,
    stroke: "#afafb7",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 50,
    cy: 50,
    fill: "none",
    r: 40,
    stroke: "#5cffd6",
    strokeLinecap: "round",
    strokeWidth: 6
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "2s",
    from: 0,
    repeatCount: "indefinite",
    to: 502
  }), /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-dasharray",
    dur: "2s",
    repeatCount: "indefinite",
    values: "150.6 100.4;1 250;150.6 100.4"
  })));
}